<!--<app-login-header></app-login-header>-->

<!--<div class="page-container">-->
<!--  <div class="page-content">-->
<!--    <div class="content-wrapper">-->

<!--      &lt;!&ndash; Industry Detail Section Start &ndash;&gt;-->
<!--      <div class="row">-->
<!--        <div class="col-lg-12">-->
<!--          <div class="panel panel-flat" id="divDetails" style="color:#5A85A3; font-size: 18px;">-->

<!--            <div class="panel-body">-->

<!--              <div class="col-lg-10" *ngIf="!industryDetailsLoader && industryDetails.length">-->
<!--                  <span style="font-size: 25px;">-->
<!--                    {{industryDetails[0]['name']}}-->
<!--                  </span>-->

<!--                <br/>-->

<!--                  <span style="font-size: 15px; margin-left: 5px;">-->
<!--                    <i class="fa fa-map-marker" aria-hidden="true"></i>-->
<!--                    {{industryDetails[0]['address']}}-->
<!--                  </span>-->

<!--                  <span style="font-size: 15px; margin-left: 5px;">-->
<!--                    <i class="fa fa-calendar" aria-hidden="true"></i>-->
<!--                    {{industryDetails[0]['industry_type']}}-->
<!--                  </span>-->
<!--              </div>-->

<!--              <div class="col-lg-12" *ngIf="industryDetailsLoader">-->
<!--                <div class="col-md-12" style="text-align: center;">-->
<!--                  <img src="/assets/images/load.gif" />-->
<!--                </div>-->
<!--              </div>-->

<!--              <div *ngIf="!industryDetailsLoader" class="col-lg-2" id="slideBtns" style="margin-top: 25px; float:right;">-->
<!--                <i style="color:#000000; margin-left: 20px; float:right; cursor: hand; " id="btnNext" class="fa fa-toggle-right" (click)="nextShow()"></i>-->
<!--                <i style=" cursor: hand; color:#000000; margin-left: 20px; display:none;float:right;" id="btnPlay" class="fa fa-play" (click)="playShow()"></i>-->
<!--                <i style=" cursor: hand; color:#000000; margin-left: 20px; float:right;" id="btnPause" class="fa fa-pause" (click)="pauseShow()"></i>-->
<!--                <i style=" cursor: hand; color:#000000; float:right;" id="btnPrev" class="fa fa-toggle-left" (click)="prevShow()"></i>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; Industry Detail Section End &ndash;&gt;-->

<!--      <div class="row">-->
<!--        <div class="col-lg-12">-->

<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="panel panel-body bg-danger-400 has-bg-image">-->
<!--              <div class="media no-margin">-->
<!--                <div class="media-body">-->
<!--                  <h3 class="no-margin" *ngIf="!countLoader">{{slideShowCardCount.total_exceedances?slideShowCardCount.total_exceedances:0}}</h3>-->
<!--                  <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                  <span class="text-uppercase text-size-mini">Total Exceedances (in a Week)</span>-->
<!--                </div>-->

<!--                <div class="media-right media-middle">-->
<!--                  <i class="icon-stats-growth2 icon-3x opacity-75"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="panel panel-body bg-primary-400 has-bg-image">-->
<!--              <div class="media no-margin">-->
<!--                <div class="media-body">-->
<!--                  <h3 class="no-margin" *ngIf="!countLoader">{{slideShowCardCount.monitoring_stations?slideShowCardCount.monitoring_stations:0}}</h3>-->
<!--                  <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                  <span class="text-uppercase text-size-mini">Monitoring Stations</span>-->
<!--                </div>-->

<!--                <div class="media-right media-middle">-->
<!--                  <i class="fa fa-desktop fa-3x opacity-75"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="panel panel-body bg-success-400 has-bg-image">-->
<!--              <div class="media no-margin">-->
<!--                <div class="media-body">-->
<!--                  <h3 *ngIf="!countLoader" class="no-margin">{{slideShowCardCount.no_of_parameters_monitored?slideShowCardCount.no_of_parameters_monitored:0}}</h3>-->
<!--                  <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                  <span class="text-uppercase text-size-mini">Parameters Monitored</span>-->
<!--                </div>-->

<!--                <div class="media-right media-middle">-->
<!--                  <i class="fa fa-area-chart fa-3x opacity-75"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-sm-6 col-md-3">-->
<!--            <div class="panel panel-body bg-warning-400 has-bg-image">-->
<!--              <div class="media no-margin">-->

<!--                <div class="media-body">-->
<!--                  <h3 *ngIf="!countLoader" class="no-margin">{{slideShowCardCount.exceeding_parameters?slideShowCardCount.exceeding_parameters:0}}</h3>-->
<!--                  <span class="no-margin" *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>-->
<!--                  <span class="text-uppercase text-size-mini">Exceeding Parameters</span>-->
<!--                </div>-->

<!--                <div class="media-right media-middle">-->
<!--                  <i class="icon-stats-growth2 icon-3x opacity-75"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="row">-->
<!--        <div class="col-lg-12">-->
<!--          <div class="col-lg-2">-->

<!--            <div>-->
<!--              <div class="panel panel-body">-->
<!--                <div class="media">-->
<!--                  <div *ngIf="!industryDetailsLoader" class="media-body">-->
<!--                    <span style="font-size: 12px; font-weight: bold;" class="media-heading">Last Data Fetched</span>-->
<!--                    <p style="font-size: 14px;" class="text-muted" *ngIf="industryDetails.length && industryDetails[0]['last_update_date']">{{industryDetails[0]['last_update_date'] | date: 'dd/MM/yyyy H:mm'}} Hrs</p>-->
<!--                    <p style="font-size: 14px;" class="text-muted" *ngIf="!industryDetails.length || !industryDetails[0]['last_update_date']">No Response</p>-->

<!--                    <ul class="icons-list" style="text-align: center;">-->
<!--                      <li>-->
<!--                        &lt;!&ndash; <img src="/assets/images/profile-icon/15.png" style="width: 60%;"> &ndash;&gt;-->
<!--                      </li>-->
<!--                      <li *ngIf="industryDetails.length && industryDetails[0]">-->
<!--                        <img title="Online" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Online'" src="/assets/images/profile-icon/online.png" style="width: 60%;">-->
<!--                        <img title="Offline" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Offline'" src="/assets/images/profile-icon/offline.png" style="width: 60%;">-->
<!--                        <img title="Delay" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Delay'" src="/assets/images/profile-icon/delay.png" style="width: 60%;">-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->

<!--                  <div *ngIf="industryDetailsLoader" class="media-body">-->
<!--                    <div class="col-md-12" style="text-align: center;">-->
<!--                      <img src="/assets/images/load.gif" />-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div>-->
<!--              <div class="panel text-center">-->
<!--                <div class="panel-body" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader">-->

<!--                  &lt;!&ndash; <div style="font-size: 12px; font-weight: bold; text-align: center;">15 minutes Average </div> &ndash;&gt;-->
<!--                  <div style="font-size: 12px; font-weight: bold; text-align: center;">Actual </div>-->

<!--                  <div class="content-group-sm svg-center position-relative" style="text-align: center;font-size: arge;">-->
<!--                    <div class="circle">-->
<!--                      <span *ngIf="latestParameterDetail.value" style="text-align: center;font-size: large;">{{latestParameterDetail.value}} {{latestParameterDetail.response_unit}}</span>-->
<!--                      <span *ngIf="!latestParameterDetail.value" style="text-align: center;font-size: large;">NA</span>-->
<!--                    </div>-->

<!--                    <div style="margin-top: 10px; font-size: 14px;">{{latestParameterDetail.param_name?latestParameterDetail.param_name:'NA'}}</div>-->

<!--                    <div style="margin-top: 2px; font-size: 12px; color: #777;" *ngIf="latestParameterDetail.min || latestParameterDetail.max">Prescribed Standard:<br/> <span *ngIf="latestParameterDetail.min">{{latestParameterDetail.min}} -</span> {{latestParameterDetail.max}} {{latestParameterDetail.std_unit}}</div>-->
<!--                    <div style="margin-top: 2px; font-size: 12px; color: #777;" *ngIf="!latestParameterDetail.min && !latestParameterDetail.max">Prescribed Standard:<br/> NA</div>-->
<!--                  </div>-->

<!--                </div>-->

<!--                <div  *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader" class="panel-body" style="height: 240px; text-align: center;">-->
<!--                  <img style="margin-top: 30%;" src="/assets/images/load.gif" />-->
<!--                </div>-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-lg-8 panel panel-flat" id="slideShowChart" style="text-align: center;">-->
<!--            <div class="panel-heading">-->
<!--              <h5 class="panel-title" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader">{{latestParameterDetail.param_name?latestParameterDetail.param_name:''}} ({{slideShowCardCount.parameters_monitored[0].station_name? slideShowCardCount.parameters_monitored[0].station_name:''}}) Device Response Chart<a class="heading-elements-toggle"><i class="icon-more"></i></a></h5>-->
<!--              <div class="heading-elements">-->
<!--                <ul class="icons-list">-->
<!--                  <li>-->

<!--                    <select [(ngModel)]="timeRange" (change)="setTimeRange()" class="form-control">-->
<!--                      <option value="1"> 1 Day </option>-->
<!--                      <option value="3"> 3 Days </option>-->
<!--                      <option value="7"> 7 Days </option>-->
<!--                      <option value="30"> 30 Days </option>-->
<!--                    </select>-->

<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;<div [chart]="parameterAllResponse" *ngIf="graphPlot" [hidden]="viewDataDetailsLoader" style="height: 400px; min-width: 310px"></div>&ndash;&gt;-->
<!--            <div class="panel-body" [chart]="parameterAllResponse" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && graphPlot" style="height: 350px;"></div>-->
<!--            <div class="panel-body text-center" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && !graphPlot"  style="height: 350px;">-->
<!--              <div class="label label-danger" style="margin-top: 150px;">No Response Found For Selected Time Range</div>-->
<!--            </div>-->

<!--            <div class="panel-body text-center" style="height: 350px;" *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader">-->
<!--              <img style="margin-top: 15%;" src="/assets/images/load.gif" />-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-lg-2">-->

<!--            <div class="panel panel-flat">-->
<!--              <div class="panel-heading" style="padding-top: 10px; padding-bottom: 10px;">-->
<!--                <h5 class="panel-title">Parameter List<a class="heading-elements-toggle"><i class="icon-more"></i></a></h5>-->
<!--              </div>-->

<!--              <table class="panel-body table" *ngIf="!countLoader">-->
<!--                <tbody>-->
<!--                <tr *ngFor="let parameter_detail of slideShowCardCount.parameters_monitored let i = index" [attr.data-index]="i">-->
<!--                  <td style="font-size: 15px;">-->
<!--                    <div style="word-break: break-all;">-->
<!--                      {{parameter_detail.station_name}} Station-->
<!--                    </div>-->

<!--                    <div>-->
<!--                      <div style="text-align: center;">-->
<!--                        <span class="label label-primary" *ngIf="slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]">{{parameter_detail.parameter_name?parameter_detail.parameter_name:'NA'}} Parameter </span>-->
<!--                        <span *ngIf="!(slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey])">{{parameter_detail.parameter_name?parameter_detail.parameter_name:'NA'}} Parameter </span>-->

<!--                        &lt;!&ndash;<span  *ngIf="slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['value']" style="color: #00B3F5; text-align: center;" class="text-bold">&ndash;&gt;-->
<!--                        &lt;!&ndash;{{slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['value']}} {{ slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['unit'] }}&ndash;&gt;-->
<!--                        &lt;!&ndash;</span>&ndash;&gt;-->

<!--                        &lt;!&ndash;<span *ngIf="!(slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]['value'])" style="color: #00B3F5; text-align: center;" class="text-bold">&ndash;&gt;-->
<!--                        &lt;!&ndash;No Response&ndash;&gt;-->
<!--                        &lt;!&ndash;</span>&ndash;&gt;-->

<!--                      </div>-->

<!--                      <div style="text-align: center; color: #777; font-size: small;">-->
<!--                        Prescribed Standard-->
<!--                        <br/>-->

<!--                        <span *ngIf="parameter_detail.min || parameter_detail.max">-->
<!--                          <span *ngIf="parameter_detail.min">{{parameter_detail.min}} - </span>-->
<!--                          <span *ngIf="parameter_detail.max">{{parameter_detail.max}} {{parameter_detail.stdunit}}</span>-->
<!--                        </span>-->

<!--                        <span *ngIf="!parameter_detail.min && !parameter_detail.max">-->
<!--                          NA-->
<!--                        </span>-->
<!--                      </div>-->

<!--                    </div>-->
<!--                  </td>-->
<!--                </tr>-->
<!--                &lt;!&ndash;<tr style="background-color: #F9FAFC;">&ndash;&gt;-->
<!--                &lt;!&ndash;<td style="font-size: 15px;">ETP - COD - 65.8 mg/l <br/>&ndash;&gt;-->
<!--                &lt;!&ndash;<span style="font-size: small;" class="pull-right">Standard - 250 mg/l</span>&ndash;&gt;-->
<!--                &lt;!&ndash;</td>&ndash;&gt;-->
<!--                &lt;!&ndash;</tr>&ndash;&gt;-->
<!--                &lt;!&ndash;<tr style="background-color: #F9FAFC;">&ndash;&gt;-->
<!--                &lt;!&ndash;<td style="font-size: 15px;">ETP - TSS - 18 mg/l <br/>&ndash;&gt;-->
<!--                &lt;!&ndash;<span style="font-size: small;" class="pull-right">Standard - 100 mg/l</span>&ndash;&gt;-->
<!--                &lt;!&ndash;</td>&ndash;&gt;-->
<!--                &lt;!&ndash;</tr>&ndash;&gt;-->
<!--                </tbody>-->
<!--              </table>-->

<!--              <div class="row" *ngIf="countLoader">-->
<!--                <div class="col-md-12" style="height: 340px; text-align: center;">-->
<!--                  <img style="margin-top: 50%;" src="/assets/images/load.gif" />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->


<!--      <div class="row" *ngIf="!industryDetails.length">-->
<!--        <div class="col-lg-12 text-center" style="height: 180px;">-->
<!--          <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 150px;">No Industry Found</div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<app-footer></app-footer>-->

<app-login-header></app-login-header>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">

      <!-- Industry Detail Section Start -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card" id="divDetails" style="color:#5A85A3; font-size: 18px;">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-10" *ngIf="!industryDetailsLoader && industryDetails.length">
                  <span style="font-size: 25px;">
                    {{industryDetails[0]['name']}}
                  </span>

                  <br/>

                  <span style="font-size: 15px; ms-2">
                    <i class="fas fa-map-marker-alt"></i>
                    {{industryDetails[0]['address']}}
                  </span>

                  <span style="font-size: 15px; ms-2">
                    <i class="fas fa-calendar-alt"></i>
                    {{industryDetails[0]['industry_type']}}
                  </span>
                </div>

                <div class="col-12" *ngIf="industryDetailsLoader">
                  <div class="text-center">
                    <img src="/assets/images/load.gif" />
                  </div>
                </div>

                <div *ngIf="!industryDetailsLoader" class="col-lg-2" id="slideBtns" style="margin-top: 25px; float:right;">
                  <i style="color:#000000; ms-3 float-end; cursor: pointer;" id="btnNext" class="fas fa-toggle-right" (click)="nextShow()"></i>
                  <i style="cursor: pointer; color:#000000; ms-3 d-none float-end;" id="btnPlay" class="fas fa-play" (click)="playShow()"></i>
                  <i style="cursor: pointer; color:#000000; ms-3 float-end;" id="btnPause" class="fas fa-pause" (click)="pauseShow()"></i>
                  <i style="cursor: pointer; color:#000000; float-end;" id="btnPrev" class="fas fa-toggle-left" (click)="prevShow()"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Industry Detail Section End -->

      <div class="row mb-4">
        <div class="col-12">
          <div class="row g-3">
            <div class="col-sm-6 col-md-3">
              <div class="card bg-danger text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <h3 class="mb-0" *ngIf="!countLoader">{{slideShowCardCount.total_exceedances?slideShowCardCount.total_exceedances:0}}</h3>
                      <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                      <span class="text-uppercase small">Total Exceedances (in a Week)</span>
                    </div>
                    <div class="ms-3">
                      <i class="fas fa-chart-line fa-3x opacity-75"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="card bg-primary text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <h3 class="mb-0" *ngIf="!countLoader">{{slideShowCardCount.monitoring_stations?slideShowCardCount.monitoring_stations:0}}</h3>
                      <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                      <span class="text-uppercase small">Monitoring Stations</span>
                    </div>
                    <div class="ms-3">
                      <i class="fas fa-desktop fa-3x opacity-75"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="card bg-success text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <h3 *ngIf="!countLoader" class="mb-0">{{slideShowCardCount.no_of_parameters_monitored?slideShowCardCount.no_of_parameters_monitored:0}}</h3>
                      <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                      <span class="text-uppercase small">Parameters Monitored</span>
                    </div>
                    <div class="ms-3">
                      <i class="fas fa-chart-area fa-3x opacity-75"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="card bg-warning text-white">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <h3 *ngIf="!countLoader" class="mb-0">{{slideShowCardCount.exceeding_parameters?slideShowCardCount.exceeding_parameters:0}}</h3>
                      <span *ngIf="countLoader"><img style="height: 30px;" src="/assets/images/load.gif" /></span>
                      <span class="text-uppercase small">Exceeding Parameters</span>
                    </div>
                    <div class="ms-3">
                      <i class="fas fa-chart-line fa-3x opacity-75"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12">
          <div class="row g-3">
            <div class="col-lg-2">
              <div class="card mb-3">
                <div class="card-body">
                  <div *ngIf="!industryDetailsLoader" class="d-flex flex-column">
                    <span class="small fw-bold">Last Data Fetched</span>
                    <p class="text-muted small" *ngIf="industryDetails.length && industryDetails[0]['last_update_date']">{{industryDetails[0]['last_update_date'] | date: 'dd/MM/yyyy H:mm'}} Hrs</p>
                    <p class="text-muted small" *ngIf="!industryDetails.length || !industryDetails[0]['last_update_date']">No Response</p>

                    <div class="text-center mt-2">
                      <div *ngIf="industryDetails.length && industryDetails[0]">
                        <img title="Online" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Online'" src="/assets/images/profile-icon/online.png" style="width: 60%;">
                        <img title="Offline" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Offline'" src="/assets/images/profile-icon/offline.png" style="width: 60%;">
                        <img title="Delay" *ngIf="(industryDetails[0]['last_update_date'] | industryStatus) == 'Delay'" src="/assets/images/profile-icon/delay.png" style="width: 60%;">
                      </div>
                    </div>
                  </div>

                  <div *ngIf="industryDetailsLoader" class="text-center">
                    <img src="/assets/images/load.gif" />
                  </div>
                </div>
              </div>

              <div class="card text-center">
                <div class="card-body" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader">
                  <div class="small fw-bold">Actual</div>

                  <div class="d-flex flex-column align-items-center my-3">
                    <div class="rounded-circle bg-light p-3 mb-2">
                      <span *ngIf="latestParameterDetail.value" class="fs-4">{{latestParameterDetail.value}} {{latestParameterDetail.response_unit}}</span>
                      <span *ngIf="!latestParameterDetail.value" class="fs-4">NA</span>
                    </div>

                    <div class="fs-5">{{latestParameterDetail.param_name?latestParameterDetail.param_name:'NA'}}</div>

                    <div class="small text-muted mt-1" *ngIf="latestParameterDetail.min || latestParameterDetail.max">
                      Prescribed Standard:<br/>
                      <span *ngIf="latestParameterDetail.min">{{latestParameterDetail.min}} -</span>
                      {{latestParameterDetail.max}} {{latestParameterDetail.std_unit}}
                    </div>
                    <div class="small text-muted mt-1" *ngIf="!latestParameterDetail.min && !latestParameterDetail.max">
                      Prescribed Standard:<br/> NA
                    </div>
                  </div>
                </div>

                <div *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader" class="card-body" style="height: 240px; display: flex; align-items: center; justify-content: center;">
                  <img src="/assets/images/load.gif" />
                </div>
              </div>
            </div>

            <div class="col-lg-8">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="card-title mb-0" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader">
                    {{latestParameterDetail.param_name?latestParameterDetail.param_name:''}}
                    ({{slideShowCardCount.parameters_monitored[0].station_name? slideShowCardCount.parameters_monitored[0].station_name:''}})
                    Device Response Chart
                  </h5>
                  <div>
                    <select [(ngModel)]="timeRange" (change)="setTimeRange()" class="form-select form-select-sm">
                      <option value="1">1 Day</option>
                      <option value="3">3 Days</option>
                      <option value="7">7 Days</option>
                      <option value="30">30 Days</option>
                    </select>
                  </div>
                </div>
                <div class="card-body p-0">
                  <div [chart]="parameterAllResponse" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && graphPlot" style="height: 350px;"></div>
                  <div class="d-flex align-items-center justify-content-center" *ngIf="!slideShowCardLoader && !slideShowLatestLoader && !countLoader && !graphPlot" style="height: 350px;">
                    <span class="badge bg-danger">No Response Found For Selected Time Range</span>
                  </div>
                  <div class="d-flex align-items-center justify-content-center" style="height: 350px;" *ngIf="slideShowCardLoader || slideShowLatestLoader || countLoader">
                    <img src="/assets/images/load.gif" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-2">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title mb-0">Parameter List</h5>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0" *ngIf="!countLoader">
                      <tbody>
                      <tr *ngFor="let parameter_detail of slideShowCardCount.parameters_monitored let i = index" [attr.data-index]="i">
                        <td class="small">
                          <div class="text-break">
                            {{parameter_detail.station_name}} Station
                          </div>
                          <div class="text-center mt-2">
                              <span class="badge bg-primary" *ngIf="slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey]">
                                {{parameter_detail.parameter_name?parameter_detail.parameter_name:'NA'}} Parameter
                              </span>
                            <span *ngIf="!(slideShowCardDetails.latest_response && slideShowCardDetails.latest_response[parameter_detail.station_id] && slideShowCardDetails.latest_response[parameter_detail.station_id][parameter_detail.paramkey])">
                                {{parameter_detail.parameter_name?parameter_detail.parameter_name:'NA'}} Parameter
                              </span>
                          </div>
                          <div class="text-center small text-muted mt-1">
                            Prescribed Standard
                            <br/>
                            <span *ngIf="parameter_detail.min || parameter_detail.max">
                                <span *ngIf="parameter_detail.min">{{parameter_detail.min}} - </span>
                                <span *ngIf="parameter_detail.max">{{parameter_detail.max}} {{parameter_detail.stdunit}}</span>
                              </span>
                            <span *ngIf="!parameter_detail.min && !parameter_detail.max">
                                NA
                              </span>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="row" *ngIf="countLoader">
                    <div class="col-12 d-flex align-items-center justify-content-center" style="height: 340px;">
                      <img src="/assets/images/load.gif" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!industryDetails.length">
        <div class="col-12 d-flex align-items-center justify-content-center" style="height: 180px;">
          <div class="fs-3 fw-bold text-danger">No Industry Found</div>
        </div>
      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>
